import { CPContactPerson } from "../../../api/models/unified";
import { Button, useAuth } from "../../../components";
import { useCustomTranslation } from "../../../helpers/translateHelpers";

interface AccountListItemProps {
  contactPerson: CPContactPerson;
}

const AccountListItem = ({ contactPerson }: AccountListItemProps) => {
  const { tCommon } = useCustomTranslation();
  const { onChangeCustomer } = useAuth();

  return (
    <div className="border-gray flex items-center justify-between border-t-1 py-2">
      <div>
        <div className="text-base font-semibold">
          {contactPerson.customerName}
        </div>
        <div className="text-gray-dark text-sm">
          {contactPerson.companyName}
        </div>
      </div>
      {!contactPerson.customerUserIsDisabled && (
        <Button
          label={tCommon("login")}
          icon="arrow-right"
          size="small"
          onClick={() => onChangeCustomer(contactPerson.customerId)}
        />
      )}
    </div>
  );
};

export default AccountListItem;
